import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
	Loader, EmptyCard, Image, MapMarker,
} from '@components/common';
import { Button } from 'react-bootstrap';
import GoogleMap from 'google-map-react';
import { isEqual } from 'lodash';
import { constants, utils } from '../../utils';

class FeedTimeLine extends Component {
	shouldComponentUpdate({ feed, timeZoneId, loading }) {
		const lastProps = this.props;
		return (
			!isEqual(feed, lastProps.feed)
			|| !isEqual(timeZoneId, lastProps.timeZoneId)
			|| !isEqual(loading, lastProps.loading)
		);
	}

	render() {
		const {
			feed, timeZoneId, loading, loadMore,
		} = this.props;

		return (
			<div className="margin-bottom-20">
				<div className="font-size-25 margin-top-35 margin-bottom-20">Activities Timeline</div>
				<Choose>
					<When condition={loading}>
						<div className="text-center">
							<Loader
								active={loading}
								spinnerOnly
							/>
						</div>
					</When>
					<Otherwise>
						<div>
							<Choose>
								<When condition={feed.list.length > 0}>
									<ul className="timeline margin-top-20 width-max-600">
										<For
											each="item"
											of={feed.list}
										>
											<li
												key={`location_details_timeline_item_${item.DateUTC}`}
												className="bullet-12 padding-left-40"
											>
												<div className="margin-bottom-10">
													<i className="rkf rkf-calendar margin-right-10" />
													<span className="margin-right-5">
														{ utils.parseUTCDateToTimeZone(item.DateUTC, timeZoneId).format('MMMM Do YYYY') }
													</span>
													<span className="margin-right-5">|</span>
													<span className="margin-right-5">
														{ utils.parseUTCDateToTimeZone(item.DateUTC, timeZoneId).format('h:mm a') }
													</span>
												</div>
												<div className="timeline-item-panel">
													<div className="padding-top-10 padding-left-20 padding-right-20">
														<div>
															<span className="text-primary">
																{ item.UserFirstName }
																{' '}
																{ item.UserLastName }
															</span>
															<span> - </span>
															<span className="font-bold">{ item.TypeName }</span>
															<span> at </span>
															<span className="font-bold">{ item.LocationName }</span>
														</div>
														<div className="simple-text margin-bottom-10">
															<i className="rkf rkf-map-pin margin-right-5" />
															<span>{ item.LocationName }</span>
														</div>
													</div>
													<If condition={item.ImageUrl}>
														<Image
															className="height-200"
															src={item.ImageUrl}
														/>
													</If>
													<If condition={item.LocationLatitude
														&& item.LocationLongitude
														&& [4, 5, 12, 13].indexOf(item.TypeId) !== -1}
													>
														<div className="height-200">
															<GoogleMap
																zoom={15}
																center={{ lat : item.LocationLatitude, lng : item.LocationLongitude }}
																bootstrapURLKeys={{ key : constants.GOOGLE_MAP_SETTINGS.key }}
																options={constants.GOOGLE_MAP_OPTIONS}
															>
																<MapMarker
																	type="job"
																	lat={item.LocationLatitude}
																	lng={item.LocationLongitude}
																/>
															</GoogleMap>
														</div>
													</If>
													<If condition={item.Content}>
														<div className="text-center timeline-item-content">
															&quot;
															{ item.Content }
															&quot;
														</div>
													</If>
												</div>
											</li>
										</For>
									</ul>
								</When>
								<Otherwise>
									<EmptyCard text="No recent activity" />
								</Otherwise>
							</Choose>
							<If condition={feed.hasNext}>
								<div className="flex-center margin-bottom-20">
									<Button
										onClick={() => loadMore()}
									>
										Load More
									</Button>
								</div>
							</If>
						</div>
					</Otherwise>
				</Choose>
			</div>
		);
	}
}

FeedTimeLine.propTypes = {
	feed       : PropTypes.object.isRequired,
	loadMore   : PropTypes.func.isRequired,
	loading    : PropTypes.bool,
	timeZoneId : PropTypes.string,
};

FeedTimeLine.defaultProps = {
	loading    : false,
	timeZoneId : '',
};

export default FeedTimeLine;
